import { motion } from 'framer-motion';
import googlePlay from "../../assets/images/vecteezy_badge-google-play-and-app-store-button-download_24237966-removebg-preview.png";
import applestore from "../../assets/images/googleplay-removebg-preview.png";

export default function DownloadAppCard() {
  return (
    <div className="flex justify-center items-center">
      <motion.div
        className="flex flex-col justify-center items-center w-[90%] p-4 h-[400px] bg-[#F3F4F6] rounded-2xl gap-5"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      >
        <h1 className="text-3xl xl:text-4xl text-center font-extrabold text-[#111928]">
          Baixe Nosso Aplicativo
        </h1>
        <p className="text-lg xl:text-xl text-center text-[#637381]">
          Baixe agora nosso aplicativo e faça seu pedido! Disponível para smartphones Android e iOS.
        </p>
        <div className="flex flex-col md:flex-row gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=br.com.hollic.vokere&hl=pt_BR&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            <img src={googlePlay} alt="Google Play" className="w-48" />
          </a>
          <a
            href="https://apps.apple.com/br/app/voker%C3%AA/id1476149761"
            target="_blank"
            rel="noreferrer"
          >
            <img src={applestore} alt="Apple Store" className="w-48" />
          </a>
        </div>
      </motion.div>
    </div>
  );
}
